import { Component, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { TraceClassDecorator } from '@sentry/angular';
import { URLS, USER_TYPES } from 'src/app/constant/constant';
import { ProviderStateService } from 'src/app/services/provider-state.service';
import { GoogleTranslateService } from 'src/app/services/google-translate.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { filter } from 'rxjs/operators';
import { LanguageService } from 'src/app/services/language.service'; // Import LanguageService
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-login-options',
  templateUrl: './login-options.component.html',
  styleUrls: ['./login-options.component.css']
})
@TraceClassDecorator()
export class LoginOptionsComponent implements OnInit, OnDestroy {
  userTypes = USER_TYPES;
  providerId: string = '';
  isPrimaryProvider: boolean = true;
  is_uk_country: boolean = false;
  doctorSignUpUrl: string =
    this.utilitiesService.getBaseUrl('PORTAL_BASE_URL') +
    'user/doctor/registration';
    slug: string = "";
  ohpSignUpUrl: string =
    this.utilitiesService.getBaseUrl('PORTAL_BASE_URL') +
    'user/other-medical-professionals/registration';
  languageOptions: { code: string, name: string }[] = [
    { code: 'en', name: 'English' },
    { code: 'hi', name: 'Hindi' },
    { code: 'fr', name: 'French' },
    { code: 'ar', name: 'Arabic'},
    { code: 'es', name: 'Spanish' },
    { code: 'pt', name: 'Portuguese' },
    { code: 'de', name: 'German' },
    { code: 'mr', name: 'Marathi' },
    { code: 'gu', name: 'Gujarati' },
    { code: 'te', name: 'Telugu' },
    { code: 'ta', name: 'Tamil' },
    { code: 'bn', name: 'Bengali' },
    { code: 'ur', name: 'Urdu' },
    { code: 'pa', name: 'Punjabi' },
    { code: 'kn', name: 'Kannada' },
    { code: 'or', name: 'Oriya' },
    { code: 'ne', name: 'Nepali' }
  ];
  selectedLanguage: string = 'en'; // Default language

  navigationSubscription: Subscription;

  constructor(
    private readonly utilitiesService: UtilitiesService,
    private readonly titleService: Title,
    private readonly route: ActivatedRoute,
    private providerStateService: ProviderStateService,
    private readonly translateService: GoogleTranslateService,
   private readonly router: Router,
   private readonly languageService: LanguageService,
   private readonly renderer: Renderer2

  ) { }
  async ngOnInit() {
    this.slug = this.providerStateService.getProviderSlug();
    await this.getLangCookie();
    this.providerId = this.providerStateService.getProviderId();
    if(URLS.IS_UK)
    {
      this.is_uk_country = true;
    }
    this.isPrimaryProvider = this.providerStateService.getIsPrimaryProvider();
    var localCode = localStorage.getItem('selectedLanguageClient');

    if (localCode !== "undefined" && localCode !== null) {
      this.selectedLanguage = localCode;
    } else {
      localStorage.setItem("selectedLanguageClient", 'en');
      this.selectedLanguage = 'en';
    }

    this.navigationSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(async () => {
        await this.getLangCookie();
        await this.arrangeButtons(this.selectedLanguage);
        await this.resizeLogo();
      });
    this.initializeLanguage();
    await this.arrangeButtons(this.selectedLanguage);
    await this.resizeLogo();
  }

  async getLangCookie() {
    function getCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
    }
    var cookieRecevied = getCookie("selectedLanguageClient");
    if (cookieRecevied !== undefined) {
      localStorage.setItem("selectedLanguageClient", cookieRecevied);
      this.deleteCookie("selectedLanguageClient");
    }
  }

  deleteCookie(name: string) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  }

  resizeLogo() {
    var lang = localStorage.getItem('selectedLanguageClient') || 'en';
    var navLogo = document.getElementById('navLogo')
    var navBar = document.getElementById('mt_top');
    if (lang !== 'en') {
      navLogo.style.height = '50px';
      navLogo.style.width = '180px';
      navBar.classList.remove('mt-n3')
      navBar.classList.add('mb-3')
    } else {
      navLogo.style.height = '';
      navLogo.style.width = '';
      navBar.classList.add('mt-n3')
      navBar.classList.remove('mb-3')
    }
  }

  arrangeButtons(langCode: string) {
    const setBtnsUIElements = document.querySelectorAll(".setBtnsUI");

    setBtnsUIElements.forEach((element) => {
      const setBtnsUI = element as HTMLElement;
      if (langCode !== 'en') {
        setBtnsUI.style.flexDirection = "column";
        setBtnsUI.style.alignItems = "center";
        setBtnsUI.style.width = "100%";
        const buttons = setBtnsUI.querySelectorAll("button");
        buttons.forEach((button) => {
          button.style.margin = "5px 0";
          button.style.display = "block";
          button.classList.add('full-width-button');
        });
      } else {
        setBtnsUI.style.flexDirection = "";
        setBtnsUI.style.alignItems = "";
        setBtnsUI.style.width = "";
        const buttons = setBtnsUI.querySelectorAll("button");
        buttons.forEach((button) => {
          button.style.margin = "";
          button.style.display = "";
          button.classList.remove('full-width-button');
        });
      }
    });
  }

  open_doctor_refferal() {
    window.open(this.doctorSignUpUrl, '_blank');
  }

  open_otherMedicalProf_refferal() {
    window.open(this.ohpSignUpUrl, '_blank');
  }

  async translatePage(event: Event) {
    const selectedLangCode = (event.target as HTMLSelectElement).value;
    this.selectedLanguage = selectedLangCode; // Update selected language
    localStorage.setItem('selectedLanguageClient', selectedLangCode); // Save to localStorage
    this.languageService.setLanguage(selectedLangCode);
    await this.translateService.setGoogleTranslateLanguage(selectedLangCode);

    // Update notranslate class based on the selected language
    if (selectedLangCode === 'en') {
      this.renderer.addClass(document.body, 'notranslate');
    } else {
      this.renderer.removeClass(document.body, 'notranslate');
    }

    await this.arrangeButtons(selectedLangCode);
    await this.resizeLogo();
  }

  initializeLanguage() {
    const savedLanguage = localStorage.getItem('selectedLanguageClient') || 'en';
    this.selectedLanguage = savedLanguage;
    this.languageService.setLanguage(savedLanguage);
    this.translateService.initGoogleTranslate().then(() => {
      this.translateService.setGoogleTranslateLanguage(savedLanguage);
      // Update notranslate class based on the saved language
      if (savedLanguage === 'en') {
        this.renderer.addClass(document.body, 'notranslate');
      } else {
        this.renderer.removeClass(document.body, 'notranslate');
      }
    });
  }

  ngOnDestroy() {
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }
}
